// extracted by mini-css-extract-plugin
export var container = "Logo-module--container--3e55l";
export var graphic = "Logo-module--graphic--2cmqD";
export var text = "Logo-module--text--3Fqdp";